"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getLocale = function () {
    var _a;
    var localeCookieName = 'PreferredLocale';
    var preferredLocale = 'de-DE';
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        preferredLocale =
            ((_a = document.cookie.match("(^|;)\\s*".concat(localeCookieName, "\\s*=\\s*([^;]+)"))) === null || _a === void 0 ? void 0 : _a.pop()) || 'de-DE';
        preferredLocale = preferredLocale.replace('_', '-');
    }
    return preferredLocale;
};
exports.default = getLocale;
//# sourceMappingURL=getLocale.js.map